const TOKEN_KEY = 'accelToken'
const ROLE_KEY = 'accelRole'

export function setSession(token, role) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(ROLE_KEY, role)
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(ROLE_KEY)
}

export function sessionRole() {
  return localStorage.getItem(ROLE_KEY) || ''
}

export function sessionToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}
